import React, { useEffect, useState } from 'react'
import * as Yup from 'yup';
import Modal from 'react-bootstrap/Modal';
import { useFormik } from "formik";
import { SlButton } from '@shoelace-style/shoelace/dist/react';
import Select from 'react-select'
import AsyncSelect from 'react-select/async';
import api from "../../services/api"
import { json, useLocation, useNavigate } from "react-router";
import { Toast } from '../../shared/Toast'
import { roles, updateBlockerFlag } from '../../utils/constants';
import { SlDrawer } from '@shoelace-style/shoelace';
import { daysBetween, NEWISODateString, SameDay, formatDateWithTime, DatetoTimestamp, End_date_cpd } from "../../utils/dateFormat";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation } from "swiper";
import PreviewFrameEdit from "../PreviewFrameEdit";
import Stepper from 'react-stepper-horizontal';
import PreviewFrame from '../PreviewFrame';
import FullImagePreview from '../../creativePreviews/FullImagePreview';
import {  debouncePromise } from '../../utils/Debounce';

export const campCreativeContext1 = React.createContext();




function Start(props) {
  const steps = [
    { title: 'LineItem' },
    { title: 'Targets' },
    { title: 'Dates & Budget' },
    { title: 'Creative Selection' },

  ];


  const navigate = useNavigate()
  const location = useLocation()
  const [advlist, setAdvlist] = useState([])
  const [deptlist, setDepartment] = useState([])
  const [campCategory, setCampCategory] = useState([])
  const [roname, setRoname] = useState([])
  const [companyName, SetCompany] = useState([])
  const [checkbox, setCheckbox] = useState(false)
  const [isBrandAd, setIsBrandAd] = useState(false)
  const [isClassified, setIsClassified] = useState(false)
  const [camptype, Setcamptype] = useState("")
  const [smShow, setSmShow] = useState(false);
  const [checker1, setchecker1] = useState(true)
  const [checker2, setchecker2] = useState(true)
  const [type, setType] = useState("")
  const [brandsList, setBrandsList] = useState([{label : "Select", value : -1}])
  const [brAdd, setBrAdd] = useState(false);
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [selected_category,setSelectedCategory]=useState()

  useEffect(() => {
    if (localStorage.getItem("role") !== roles.ops)
      navigate("/pagenotfound")
    getCategory();
    setType(order?.order_type === "Editorial" ? 'Editorial' :  "Local")
  }, [])

  useEffect(() => {

    const getCategories = async () => {
       const result = await api({
        url: "/birdview/alphacategory",
        method: "POST",
        date:{brand_type:"alpha"}
      })
      setCategories(result.data);
    }
    getCategories();

  }, []);

  useEffect(() => {
     if(!selected_category) return;

     const fetchSubCategories = async() =>{
        const result = await api({
          url: "/birdview/alphasubcategory",
          method: "POST",
          data: { category_id : selected_category},
        })
        if(result.status==="SUCCESS"){
           setSubCategories(result.data);
        }
     }
     fetchSubCategories();
  }, [selected_category]);

let order = location.state.order
let sales_person_id = order.sales_person_id

  const editaction = async () => {
    const start = location.state.start
    // formik.setFieldValue("brand_type", start.brand_type || 0)
    if(start.brand_id){
      getBrands(start.brand_id)
    }
    if(start.category_id){
      setSelectedCategory(start.category_id)
      setTimeout(() => formik.setFieldValue("category_id", start.category_id), 0)
    }
    if(start.sub_category_id){
      setTimeout(() => formik.setFieldValue("sub_category_id", start.sub_category_id), 0)
    }
    formik.setFieldValue("campaign_name", start.campaign_name)
    setTimeout(() => formik.setFieldValue("brand_id",start.brand_id),0)
    Setcamptype(start.campaign_type)
    setTimeout(() => formik.setFieldValue("campaign_type", start.campaign_type), 0)
    if(location.state.isBrandAd){
      setIsBrandAd(true)
    }
    if(location.state.isClassified){
      setIsClassified(true)
    }
    if (location.state.type === 'DFP') {
      setType("DFP")
      setCheckbox(true);
    }
    else { 
      setType(order?.order_type === "Editorial" ? 'Editorial' :  "Local")
    }

  }
  const prefilling = async () => {
    const start = location.state.prefillingData.start
    if(start.brand_id){
      getBrands(start.brand_id)
    }
    formik.setFieldValue("campaign_name", start.campaign_name)
    setTimeout(() => formik.setFieldValue("brand_id",start.brand_id),0)
    Setcamptype(start.campaign_type)
    setTimeout(() => formik.setFieldValue("campaign_type", start.campaign_type), 0)
    setTimeout(() => formik.setFieldValue("category_id", start.category_id), 0)
    setTimeout(() => formik.setFieldValue("sub_category_id", start.sub_category_id), 0)

  }

  const defaultValue = (options, value) => {
    return options ? options.filter((option) => option.value === value) : "";
  };
  const getCategory = async () => {
    try {
      let res = await api({
        url: '/user/campaign/name',
        method: 'GET',
        responseType: 'json'
      })

      setCampCategory(res.data);
    } catch (error) {
      console.error(error);
      if (error.response.status === 401)
        navigate("/")
    }
  }
  const getBrands = async(checker) =>{
    try {
      if(!checker )
          return []
      let requestObj = null
      if(typeof(checker) === 'number'){
        requestObj = {brand_id : +checker}
      }
      else if (checker){
        requestObj = {search : checker}
      }
      if(!requestObj)
        return []
      // requestObj.brand_type = formik.values.brand_type ? 'finite' : 'infinite'
      requestObj.sales_person_id = sales_person_id
      const brandsResult = await api({
        url: 'user/sales_persons/getBrands',
        method:"POST",
        responseType:"json",
        data: requestObj
      })
      if(brandsResult?.code === 200){
        setBrandsList(brandsResult.data)
        return brandsResult.data
      }
      else 
        return []
    } catch (error) {
      console.error("Error @ getBrands",error)
    }
  }
  const AddBrand = async (value) =>{
    try {
      const addBrandResult = await api({
      url:"user/sales_persons/addBrand",
      method: "POST",
      responseType: "json",
      data: {value}
    })
    if(addBrandResult.code === 200){
      Toast('success', 'Successfully Inserted')
      setBrAdd({})
      // getBrands()
    }
    } catch (error) {
      console.error("Error @ AddBrand", error)
    }
    
  }


  const check = (check) => {
    if ((camptype === "CPC" || camptype === "CPM") && check === "ronum") {
      return Yup.string().required("Ro Number is required")
    }
    if ((smShow) && (check === "dept")) {
      return Yup.string().required("department name is required")
    }
    else {
      return Yup.string()
    }
  }
  const formik = useFormik({
    initialValues: {
      campaign_name: "",
      campaign_type: "",
      brand_id: -1,
      category_id : null,
      sub_category_id : null,
      // brand_type: 1
    },
    validateOnChange: true,
    validateOnBlur: true,
    validationSchema: Yup.object({

      campaign_name: Yup.string().required("LineItem Name is required").matches(/^[a-zA-Z0-9_][a-zA-Z0-9_\s.]*$/, "Enter Valid LineItem Name"),
      campaign_type: Yup.string().required("LineItem type is required"),
      brand_id: Yup.number().required("Brand is required").min(1, "Brand is required"),
      category_id: Yup.number().nullable().when([], { is: () => order.new_user_type === 5, then: s => s.required("Category is required").min(1), otherwise: s => s.notRequired().nullable() }),
      sub_category_id: Yup.number().nullable().when([], { is: () => order.new_user_type === 5, then: s => s.required("Sub Category is required").min(1), otherwise: s => s.notRequired().nullable() }),
    }),
    onSubmit: async (values) => {
      let flag = 0;
      try {
        let reqData = {
          campaign_name: values.campaign_name
        }
        if(location?.state?.action === "edit")
          reqData.campaign_id = location.state.id
        let res = await api({
          url: '/lineitems/getCampaignName',
          method: 'POST',
          responseType: 'json',
          data: reqData
        })
        if (res.data) {
            flag = 1
        }
      } catch (error) {
        console.error(error);
        if (error.response.status === 401)
          navigate("/")
      }
      if (flag === 1) {
        Toast('error', 'LineItem Name Already Exist')
      }
      else {
        let start_preview = { campaign_name: values.campaign_name, campaign_type: values.campaign_type, brand_id: fun(formik.values.brand_id, brandsList), isBrandAd, isClassified }
        let result = { ...location.state, start: values, type: type, order, start_preview: start_preview, isBrandAd, isClassified }
        navigate("/home/campaign/target", { state: result})
      }
    }
  })
  
  useEffect(() => {
    if (location.state.start) {
      editaction()
    }
    else if(location?.state?.prefillingData?.start){
      prefilling()
    }
    if(order?.package_type === 'Classified'){
      setIsClassified(true)
    }
  }, [])

  const debouncedGetBrands = debouncePromise(getBrands, 500); // Adjust the delay as needed
  return (
    <>
      <div class="campaign-drawer">
        <div className='title'>
          <legend>Create LineItem</legend>
         <sl-icon name="x" type="button" className="text-danger mt-2" style={{ right: 20, position: "absolute" }} onClick={() => { if(location.state.action === "edit" && (location.state?.status === 5 || location?.state?.status === 2)){updateBlockerFlag(location.state.id, false);}  navigate(`/home/order/${order.id}`, {state:{order}}) }}></sl-icon>
        </div>
        <div className='grid grid-cols-2 divide-x mt-3'>
          <div className='mobHide'>
            <div>
              <div>
              <section className="flex gap-6">
                  <div className="basis-7/12 grid gap-6 grid-cols-2">
                    {
                      <>

                        {formik.values && <>
                          <section className="bg-slate-50 py-4 px-6 rounded-lg">
                            <h6 className="mb-2">LineItem Creation</h6>
                            {<div className="flex justify-between mb-2">
                              <label className="text-slate-500">LineItem Name : </label>
                              {formik.values.campaign_name ? < b>{formik.values.campaign_name}</ b> : < b>{"  "} -</ b>}
                            </div>}
                            {<div className="flex justify-between mb-2">
                              <label className="text-slate-500">LineItem Type : </label>
                              {formik.values.campaign_type ? < b>{formik.values.campaign_type}</ b> : < b>{"  "} -</ b>}
                            </div>}
                            {<div className="flex justify-between mb-2">
                              <label className="text-slate-500">Type : </label>
                              {type ? < b>{type}</ b> : < b>{"  "} -</ b>}
                            </div>}
                            {<div className="flex justify-between mb-2">
                              <label className="text-slate-500">Brand : </label>
                              {formik.values.brand_id ? < b>{fun(+formik.values.brand_id, brandsList) }</ b> : < b>{"  "} -</ b>}
                            </div>}
                          </section>
                          {<section className="bg-slate-50 py-4 px-6 rounded-lg">
                            <h6 className="mb-2">Target</h6>
                            {(Array.isArray(location.state?.target_preview?.lang_ids) && location.state.target_preview?.lang_ids?.length > 0) && <div className="flex justify-between mb-2"><label className="text-slate-500">Languages :</label> </div>}
                            { location.state.target_preview?.lang_ids?.map((item, i) => {
                              return item
                            })}
                            {(Array.isArray(location.state.target_preview?.zone_ids) && location.state.target_preview?.zone_ids?.length > 0) && <div>
                              {<label className="text-slate-500">Zones : </label>}
                              <b>{location.state.target_preview?.zone_ids?.map((item) => {
                                return item
                              }
                              )}</b>
                            </div>}
                            {!location.state.target_preview?.zone_ids?.length ? <>
                            {((Array.isArray(location.state.target_preview?.state_ids) && location.state.target_preview.state_ids?.length > 0) && <div>
                              <label className="text-slate-500">States : </label>
                              <b>{location.state.target_preview.state_ids.map((item, i) => {
                                return item
                              }
                              )}</b>
                            </div>)}
                            {(Array.isArray(location.state.target_preview?.district_ids) && location.state.target_preview?.district_ids?.length > 0) && <div>
                              {<label className="text-slate-500">Districts : </label>}
                              <b> {location.state.target_preview.district_ids.map((item, i) => {
                                return item
                              }
                              )}</b>
                            </div>}
                            {(Array.isArray(location.state.target_preview?.ex_districts) && location.state.target_preview?.ex_districts?.length > 0) &&<div>
                              {<label className="text-slate-500">Excluded Districts : </label>}
                              <b> {location.state.target_preview.ex_districts.map((item, i) => {
                                return item
                              }
                              )}</b>
                            </div>}
                            {(Array.isArray(location.state.target_preview?.constituencies) && location.state.target_preview?.constituencies.length > 0) && <div>
                                {location.state.target_preview?.exclude ? <label className="text-slate-500">Excluded Constituencies : </label> : <label className="text-slate-500">Constituencies : </label>}
                                <b> {location.state.target_preview.constituencies.map((item, i) => {
                                return item
                              }
                              )}</b>
                            </div>}
                            {(Array.isArray(location.state.target_preview?.mandal_ids) && location.state.target_preview.mandal_ids?.length > 0) && <div>
                              {<label className="text-slate-500">Mandals : </label>}
                              <b> {location.state.target_preview.mandal_ids.map((item, i) => {
                                return item
                              }
                              ) }</b>
                            </div>}
                            {(Array.isArray(location.state.target_preview?.ex_mandals) && location.state.target_preview?.ex_mandals?.length > 0) && <div>
                              {<label className="text-slate-500">Excluded Mandals : </label>}
                              <b>{location.state.target_preview.ex_mandals.map((item, i) => {
                                return item
                              }
                              )}</b>
                            </div>}
                            {(Array.isArray(location.state.target_preview?.village_ids) && location.state.target_preview?.village_ids?.length > 0) &&<div>
                              {<label className="text-slate-500">villages : </label>}
                              <b> { location.state.target_preview.village_ids.map((item, i) => {
                                return item
                              }
                              )}</b>
                            </div>}
                            {(Array.isArray(location.state.target_preview?.ex_villages) && location.state.target_preview?.ex_villages?.length > 0) && <div>
                              {<label className="text-slate-500">Excluded villages : </label>}
                              <b> {location.state.target_preview.ex_villages.map((item, i) => {
                                return item
                              }
                              )}</b>
                            </div>}
                            </> : null}
                            {<div>
                              {<label className="text-slate-500">App Category : </label>}
                              {(Array.isArray(location.state.target_preview?.app) && location.state.target_preview?.app?.length > 0) ? location.state.target_preview.app.map((item, i) => {

                                return item
                              }
                              ) : < b>{"  "} -</ b>}
                            </div>}
                            {(Array.isArray(location.state.target_preview?.minspend) && location.state.target_preview?.minspend?.length > 0) && <div>
                              {<label className="text-slate-500">Minimum Spend : </label>}
                              <b> {location.state.target_preview.minspend.map((item, i) => {

                                return item
                              }
                              ) }</b>
                            </div>}
                            {<div>
                              {location.state.target_preview?.min_age > 0 ? <p><label className="text-slate-500">Min Age</label> : {location.state.target_preview?.min_age}</p> : < b>{"  "} -</ b>}
                              {location.state.target_preview?.max_age > 0 ? <p><label className="text-slate-500">Max Age</label> : {location.state.target_preview?.max_age}</p> : < b>{"  "} -</ b>}
                              {location.state.target_preview?.os !== '' ? <p><label className="text-slate-500">OS</label> : {location.state.target_preview?.os}</p> : < b>{"  "} -</ b>}
                              {location.state.target_preview?.android_version !== '' ? <p><label className="text-slate-500">Android Version</label> : {location.state.target_preview?.android_version}</p> : null}
                              {location.state.target_preview?.ios_version !== '' ? <p><label className="text-slate-500">IOS Version</label> : {location.state.target_preview?.ios_version}</p> : null}
                              {location.state.target_preview?.gender !== null ? <p><label className="text-slate-500">Gender</label> : {location.state.target_preview?.gender} </p> : < b>{"  "} -</ b>}
                            </div>}
                          </section>}
                          {<section className="bg-slate-50 py-4 px-6 rounded-lg">
                            <h6 className="mb-2">Budget</h6>
                            {formik.values?.campaign_type === "CPC" && <div className="flex justify-between mb-2">
                              <label className="text-slate-500">CPC Price : </label>
                              {formik.values?.campaign_type === "CPC" && location.state?.date_budget_preview?.cpc_price > 0 ? <b>{location.state?.date_budget_preview?.cpc_price}</b> : < b>{" "} -</ b>}
                            </div>}

                            {formik.values?.campaign_type === "CPD" && <div className="flex justify-between mb-2">
                              <label className="text-slate-500">CPD Price : </label>
                              {formik.values?.campaign_type === "CPD" && location.state?.creatselect?.cpd > 0 ? <b>{location.state?.creatselect?.cpd}</b> : <>-</>}
                            </div>}

                            {formik.values?.campaign_type === "CPM" && <div className="flex justify-between mb-2">
                              <label className="text-slate-500">CPM Price : </label>
                              {formik.values?.campaign_type === "CPM" && location.state?.date_budget_preview?.cpm > 0 ? < b>{location.state?.date_budget_preview?.cpm}</ b> : < b>{" "} -</ b>}
                            </div>}

                            {formik.values?.campaign_type !== "CPD" && <div className="flex justify-between mb-2">
                              <label className="text-slate-500">Daily Budget : </label>
                              {location.state?.date_budget_preview?.daily_budget > 0 ? < b>{location.state?.date_budget_preview?.daily_budget}</ b> : < b>{" "} -</ b>}
                            </div>}

                            {formik.values?.campaign_type !== "CPD" && <div className="flex justify-between mb-2">
                              <label className="text-slate-500">Total Budget : </label>
                              {location.state?.date_budget_preview?.total_budget > 0 ? < b>{location.state?.date_budget_preview?.total_budget}</ b> : < b>{" "} -</ b>}
                            </div>}

                            {formik.values?.campaign_type === "CPC" && <div className="flex justify-between mb-2">
                              <label className="text-slate-500">Daily Click Cap : </label>
                              {formik.values?.campaign_type === "CPC" && location.state?.date_budget_preview?.daily_click_cap > 0 ? < b>{location.state?.date_budget_preview?.daily_click_cap}</ b> : < b>{" "} -</ b>}
                            </div>}

                            {formik.values?.campaign_type === "CPM" && <div className="flex justify-between mb-2">
                              <label className="text-slate-500">Daily Impression Cap : </label>
                              {formik.values?.campaign_type === "CPM" && location.state?.date_budget_preview?.daily_imp_cap > 0 ? < b>{location.state?.date_budget_preview?.daily_imp_cap}</ b> : < b>{" "} -</ b>}
                            </div>}

                            {formik.values?.campaign_type === "CPC" && <div className="flex justify-between mb-2">
                              <label className="text-slate-500">Total Click Cap : </label>
                              {formik.values?.campaign_type === "CPC" && location.state?.date_budget_preview?.tot_click_cap > 0 ? < b>{location.state?.date_budget_preview?.tot_click_cap}</ b> : < b>{" "} -</ b>}
                            </div>}

                            {formik.values?.campaign_type === "CPM" && <div className="flex justify-between mb-2">
                              <label className="text-slate-500">Total Impression Cap : </label>
                              {formik.values?.campaign_type === "CPM" && location.state?.date_budget_preview?.tot_imp_cap > 0 ? < b>{location.state?.date_budget_preview?.tot_imp_cap}</ b> : < b>{" "} -</ b>}
                            </div>}
                          </section>}
                          {<section className="bg-slate-50 py-4 px-6 rounded-lg">
                            <h6 className="mb-2">Date</h6>
                            {!isBrandAd ? 
                            <>{<div className="flex justify-between mb-2">
                              <label className="text-slate-500">Start Date :</label>
                              {((location.state?.start?.campaign_type === "CPD" && location.state?.date_budget_preview?.start) || (location.state?.start?.campaign_type !== "CPD" && location.state?.date_budget_preview?.start_date)) ?
                                < b>{location.state?.start?.campaign_type === 'CPD' ? DatetoTimestamp(location.state?.date_budget_preview?.start) : DatetoTimestamp(location.state?.date_budget_preview?.start_date)}</ b> : < b>{" "} -</ b>}
                            </div>}
                            {<div className="flex justify-between mb-2">
                              <label className="text-slate-500">End Date :</label>
                              {((location.state?.start?.campaign_type === "CPD" && location.state?.date_budget_preview?.start) || (location.state?.start?.campaign_type !== "CPD" && location.state?.date_budget_preview?.end_date)) ? < b>{location.state?.start?.campaign_type !== 'CPD' ? DatetoTimestamp(location.state?.date_budget_preview?.end_date) : End_date_cpd(location.state?.date_budget_preview?.start)}</ b> : < b>{" "} -</ b>}
                            </div>}</> : <>
                            {<div className="flex justify-between mb-2">
                              <label className="text-slate-500">Start Date :</label>
                              {((location.state?.start?.campaign_type === "CPD" && location.state?.date_budget_preview?.start_date)) ?
                                < b>{DatetoTimestamp(location.state?.date_budget_preview?.start_date)}</ b> : < b>{" "} -</ b>}
                            </div>}
                            {<div className="flex justify-between mb-2">
                              <label className="text-slate-500">End Date :</label>
                              {((location.state?.start?.campaign_type === "CPD" && location.state?.date_budget_preview?.end_date)) ?
                              < b>{DatetoTimestamp(location.state?.date_budget_preview?.end_date)}</ b> : < b>{" "} -</ b>}
                            </div>}
                            </>
                            }
                            {location.state?.start?.campaign_type !== 'CPD' && location.state?.date_budget_preview?.datelist?.length !== 0 ? <div className="flex justify-between mb-2" style={{"display": "block"}}>
                              <label className="text-slate-500">Day Time Slots :</label>
                              {location.state?.date_budget_preview?.datelist?.length !== 0 ? <>{(location.state?.date_budget_preview?.datelist?.length > 0 ? location.state?.date_budget_preview?.datelist.map((item, i) => (<p key={i}> {DatetoTimestamp(item.sdate)} {<br />}  {DatetoTimestamp(item.edate)}</p>)) : null)}</> : <div>None</div>
                              }
                              { }</div> : null}
                            {location.state?.date_budget_preview?.till_date && <p> Till End Date</p>}

                          </section>}
                          {<section className="bg-slate-50 py-4 px-6 rounded-lg">
                            <h6>Create Select</h6>
                            {location.state?.creatselect_preview?.ad_code !== '' && location.state?.type === "DFP" && <div className="flex justify-between mb-2"><label className="text-slate-500">Ad Code :</label> {location.state?.creatselect_preview?.ad_code}</div>}
                            {location.state?.creatselect_preview?.line_item_code !== null && location.state?.type === "DFP" && <div className="flex justify-between mb-2"><label className="text-slate-500">Line Item Code :</label> {location.state?.creatselect_preview?.line_item_code}</div>}
                            {location.state?.creatselect_preview?.dfp_creative_ids && type === "DFP" ? <div className="flex justify-between mb-2"><label className="text-slate-500">DFP Creative Ids :</label> {location.state?.creatselect_preview?.dfp_creative_ids?.split(',')?.map(item => <>{item}<br/></>)}</div> : null}
                            {location.state?.creatselect_preview?.post_type !== null && location.state?.type === "DFP" && <div className="flex justify-between mb-2"><label className="text-slate-500"> Post Type :</label> {location.state?.creatselect_preview?.post_type}</div>}
                            {location.state?.creatselect_preview?.news_type !== null && location.state?.type === "DFP" && <div className="flex justify-between mb-2"><label className="text-slate-500"> News Type :</label> {location.state?.creatselect_preview?.news_type}</div>}
                            {location.state?.creatselect_preview?.dfp_backfill_ad_type && location.state?.type === "DFP" && <div className="flex justify-between mb-2"><label className="text-slate-500"> Dfp Backfill Ad Type :</label> {location.state?.creatselect_preview?.dfp_backfill_ad_type}</div>}
                            {location.state?.creatselect_preview?.slotuuid && location.state?.type === "DFP" && <div className="flex justify-between mb-2"><label className="text-slate-500"> Slot Id :</label> {location.state?.creatselect_preview?.slotuuid}</div>}
                            {location.state?.creatselect_preview?.banner_size?.length && location.state?.type === "DFP" ? <div className="flex justify-between mb-2"><label className="text-slate-500"> Banner Size :</label> {location.state?.creatselect_preview?.banner_size?.join(',')}</div> : null}

                            {<div className="flex justify-between mb-2"><label className="text-slate-500">Creative Type  :</label> {location.state?.creatselect_preview?.creative_type !== '' ? location.state?.creatselect_preview?.creative_type : "-"}</div>}
                            {location.state?.creatselect_preview?.frequency_cap > 0 && <div className="flex justify-between mb-2"><label className="text-slate-500">Frequency :</label>  {location.state?.creatselect_preview?.frequency_cap}</div>}
                            {location.state?.creatselect_preview?.frequency_cap_type !== '' && location.state?.creatselect_preview?.positiontype === "rotation" && <div className="flex justify-between mb-2"><label className="text-slate-500">Frequency Cap Type :</label>  {location.state?.creatselect_preview?.frequency_cap_type}</div>}
                            <div className="flex justify-between mb-2"><label className="text-slate-500">Position : </label>{location.state?.creatselect_preview?.position}</div>
                            {location.state?.creatselect_preview?.positiontype !== '' && <div className="flex justify-between mb-2"><label className="text-slate-500">Position Type :</label> {location.state?.creatselect_preview?.positiontype}</div>}
                            {location.state?.creatselect_preview?.positiontype === 'rotation' && location.state?.creatselect_preview?.action_type !== null && <div className="flex justify-between mb-2"><label className="text-slate-500">Action type :</label> {location.state?.creatselect_preview?.action_type}</div>}
                            {localStorage.getItem("role") === roles.ops || localStorage.getItem("role") === roles.salesperson ? <div className="flex justify-between mb-2"><label className="text-slate-500">Priority :</label> {+location.state?.creatselect_preview?.priority ? +location.state?.creatselect_preview?.priority : < b>{" "} -</ b>}</div> : null}
                            {location.state?.type !== "DFP" ? <div className="flex justify-between mb-2"><label className="text-slate-500">Encryption  :</label> {location.state?.creatselect_preview?.encryption ? 'True' : 'False'}</div> : null}
                            {location.state?.type === "DFP" ? <div className="flex justify-between mb-2"><label className="text-slate-500">Hidden  :</label> {location.state?.creatselect_preview?.dfp_hidden ? 'True' : 'False'}</div> : null}
                            {location.state?.type === "DFP" ? <div className="flex justify-between mb-2"><label className="text-slate-500">DFP IMA  :</label> {location.state?.creatselect_preview?.dfp_ima ? 'True' : 'False'}</div> : null}
                            {location.state?.type === "DFP" ? <div className="flex justify-between mb-2"><label className="text-slate-500">DFP PGDEAL  :</label> {location.state?.creatselect_preview?.dfp_pgdeal ? 'True' : 'False'}</div> : null}
                            {location.state?.type === "DFP" ? <div className="flex justify-between mb-2"><label className="text-slate-500">DFP IMA Obstacle :</label> {location.state?.creatselect_preview?.dfp_ima_obs ? 'True' : 'False'}</div> : null}
                          </section>}
                          {location.state.discount_obj ? <section className="bg-slate-50 py-4 px-6 rounded-lg">
                            <h6>Discount</h6>
                            {location.state.discount_obj.discount_no ? <div className="flex justify-between mb-2"><label className="text-slate-500">Discount :</label> {`${location.state.discount_obj.discsign ? "+" : "-"} ${location.state.discount_obj.discount_no} %`}</div> : null}
                            {location.state.discount_obj.actualPrice ? <div className="flex justify-between mb-2"><label className="text-slate-500">Actual Price  :</label> {location.state.discount_obj.actualPrice}</div> : null}
                            {location.state.discount_obj.discountPrice ? <div className="flex justify-between mb-2"><label className="text-slate-500">After Discount  :</label> {location.state.discount_obj.discountPrice}</div> : null}
                            </section> : null}
                        </>
                        }
                      </>
                    }
                  </div> {<section className="basis-5/12 rounded-2xl overflow-hidden">
                    {<> {(location.state?.creatselect_preview?.creatives_preview?.length > 0 ?
                      <Swiper
                        spaceBetween={0}
                        pagination={true}
                        navigation={true}
                        modules={[Navigation, Pagination]}
                        className="mySwiper"
                        style={{ width: "460px" }}>
                        {location.state?.creatselect_preview?.creatives_preview?.map((campPreview) => <SwiperSlide><campCreativeContext1.Provider value={{ campPreview }}><PreviewFrameEdit showPreview={true} /></campCreativeContext1.Provider></SwiperSlide>)}</Swiper> : <>
                        <section className="preview-mobile">
                        <div className="preview-inner">
                          <div className="preview-full-image">
                           <div className='mt-60 ml-1 preview-text'>Preview of your creative will be shown here once after you select your creative</div>
                          </div>
                        </div></section>
                      </>)} </>}
                  </section>}

                </section>
              </div>
            </div>
          </div>
          <div>
            <div>


              <form onSubmit={formik.handleSubmit} className='contents'>
                <Stepper
                  steps={steps}
                  activeStep={0} />
                <fieldset>
                  <h4 className='menu-title pl-0'> LineItem</h4>
                  <div className="mb-4">
                    <label htmlFor="" className="form-label font-medium">LineItem Type</label>
                    < b className="text-red-600">*</ b>
                    <select
                      className="form-select"
                      aria-label="Default select example"
                      name="campaign_type"
                      placeholder='select sales_person name'
                      value={formik.values.campaign_type}
                      onBlur={formik.handleBlur}
                      disabled={location?.state?.status === 2}
                      onChange={(e) => { formik.handleChange(e); Setcamptype(e.target.value); if(e.target.value === "CPD"){}else {setIsBrandAd(false)}}}
                    >   <option value="" selected>Select LineItem type</option>
                      {order.ispackage ? null : <><option value="CPC">CPC</option>
                      <option value="CPM">CPM</option></>}
                      <option value="CPD">CPD</option>

                    </select>
                    {formik.errors.campaign_type && formik.touched.campaign_type ? <div className="text-red-600">{formik.errors.campaign_type}</div> : null}

                  </div>
                  <div className='d-flex items-center gap-2 mb-2'>
                  {
                    formik.values.campaign_type !== "" && location?.state?.action !== "edit" && order?.package_type !== 'Classified' ?
                      <div className='d-flex gap-1'>
                        <input className="form-check-input" type="checkbox" id="flexCheckDefault"
                          checked={checkbox}
                          onChange={() => {setCheckbox(!checkbox); setIsBrandAd(false); setIsClassified(false); if(!checkbox === true){  setType("DFP"); }else {setType(order.order_type === "Editorial" ? 'Editorial' :  "Local")} }
                          }
                        />
                        <label className="form-check-label" htmlFor="flexCheckDefault">DFP</label>
                      </div>

                      : null
                  }
                  {
                    formik.values.campaign_type === 'CPD' && order?.package_type !== 'Classified' ?
                    <div className='d-flex gap-1'>
                        <input className="form-check-input" type="checkbox" id="flexCheckDefault1"
                          checked={isBrandAd}
                          onChange={() => {setIsBrandAd(!isBrandAd); setCheckbox(false); setIsClassified(false); setType(order.order_type === "Editorial" ? 'Editorial' :  "Local")}}
                          disabled={location?.state?.action === 'edit'}
                        />
                        <label className="form-check-label" htmlFor="flexCheckDefault1">Brand Ad</label>
                    </div>
                    : 
                    null

                  }
                  {
                    formik.values.campaign_type === 'CPD' ?
                    <div className='d-flex gap-1'>
                        <input className="form-check-input" type="checkbox" id="flexCheckDefault2"
                          checked={isClassified}
                          onChange={() => {setIsClassified(!isClassified); setCheckbox(false); setIsBrandAd(false); setType(order.order_type === "Editorial" ? 'Editorial' :  "Local")}}
                          disabled={location?.state?.action === 'edit' || order?.package_type === 'Classified'}
                        />
                        <label className="form-check-label" htmlFor="flexCheckDefault2">Classified Ad</label>
                    </div>
                    : 
                    null

                  }
                  </div>
                  <div className="mb-4">
                    <label htmlFor="" className="form-label font-medium">LineItem Name</label>
                    < b className="text-red-600">*</ b>
                    <input type="text"
                      className="form-control"
                      name="campaign_name"
                      placeholder='Enter LineItem name'
                      value={formik.values.campaign_name}
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}

                    />
                    {formik.errors.campaign_name && formik.touched.campaign_name ? <div className="text-red-600">{formik.errors.campaign_name}</div> : null}

                  </div>
                  <div className="row mb-4 align-items-end">
                  <div className="col">
                      <label htmlFor="" className="form-label font-medium">Brand Name</label><span className="text-red-600">*</span>
                      <div className="flex gap-3 items-center">
                        <div className="flex-grow">
                          <AsyncSelect type="text"
                      className=""
                      name="brand_id"
                      placeholder='Select brand'
                      value={defaultValue(brandsList, formik.values.brand_id)}
                      onBlur={formik.handleBlur}
                      onChange={selected => { formik.setFieldValue('brand_id', selected.value);}}
                      loadOptions={debouncedGetBrands}
                      defaultOptions={brandsList}
                    />
                     {formik.errors.brand_id && formik.touched.brand_id ? <div className="text-red-600">{formik.errors.brand_id}</div> : null}
                        </div>
                    {/* <div class="form-check form-switch">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="finiteInfinte"
                      checked={formik.values.brand_type === 1}
                      onChange={() => {
                        formik.setFieldValue("brand_type", formik.values.brand_type === 1 ? 0 : 1)
                        setBrandsList([])
                        formik.setFieldValue("brand_id", -1)
                      }}
                    />
                    <label class="form-check-label" for="finiteInfinte">
                      {formik.values.brand_type ? "Finite" : "InFinite"}
                    </label>
                  </div> */}
                      </div>
                    </div>
                    </div>
                    {order.new_user_type === 5 && 
                    <div>
                      <div className="my-2">
                        <label className="form-label font-medium">Category <span className="text-red-600">*</span></label>
                        <Select
                          options={categories}
                          value={categories?.find(c => c.value === formik.values.category_id)}
                          onChange={(value) => {
                            setSelectedCategory(value?.value); 
                            formik.setFieldValue('category_id', value?.value);
                            if (value?.value) {
                              formik.setFieldValue('sub_category_id', null);
                              setSubCategories([]);
                            }
                          }}
                          onBlur={() => formik.setFieldTouched('category_id', true)}
                          placeholder="Select Category"
                        />
                        {formik.touched.category_id && formik.errors.category_id && (
                          <div className="text-red-500 text-sm mt-1">{formik.errors.category_id}</div>
                        )}
                      </div>
                      
                      {selected_category && (
                        <div className="my-3">
                          <label className="form-label font-medium">Sub Category <span className="text-red-600">*</span></label>
                          <Select
                            options={subCategories}
                            value={subCategories?.find(sc => sc.value === formik.values.sub_category_id)}
                            onChange={(value) => formik.setFieldValue('sub_category_id', value?.value)}
                            onBlur={() => formik.setFieldTouched('sub_category_id', true)}
                            placeholder="Select Sub Category"
                          />
                          {formik.touched.sub_category_id && formik.errors.sub_category_id && (
                            <div className="text-red-500 text-sm mt-1">{formik.errors.sub_category_id}</div>
                          )}
                        </div>
                      )}
                    </div>
                  }
                    <Modal
                    size="sm"
                    backdrop='static'
                    show={brAdd?.show}
                    onHide={() => {
                      setBrAdd({});
                    }}
                    aria-labelledby="example-modal-sizes-title-sm"
                  >
                    <Modal.Header closeButton>
                      <Modal.Title id="example-modal-sizes-title-sm">
                        Add Brand
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <div className="mb-4">
                        <input type="text"
                          className="form-control"
                          aria-label="Default select example"
                          placeholder='Enter Brand name'
                          value={brAdd.value}
                          onChange={(e)=>{setBrAdd({...brAdd, value: e.target.value})}}
                        />
                      </div>
                      <div className="">
                        <SlButton variant="primary" type="button" onClick={() => {
                          if(brAdd.value === ''){
                            Toast('error', 'Brand Name Required')
                            return
                          }
                          for (let i = 0; i < brandsList?.length; i++) {
                            if (brandsList[i].label.toLowerCase() === brAdd.value.toLowerCase()) {
                              Toast('error', 'Brand Name Already Exist')
                              return
                            }
                          }
                          AddBrand(brAdd.value)
                        }} >Submit</SlButton>
                      </div>
                    </Modal.Body>
                  </Modal>

                  <div>
                    <SlButton type='submit' variant="primary" >Next</SlButton>
                  </div>
                </fieldset>
              </form>

            </div>
          </div>
        </div>
      </div>
    </>
  )
}


const fun = (id, list) => {
 
  for (let i = 0; i < list.length; i++) {
    if (list[i].value === id) {
      return (list[i].label)
    }
  }
  return "-"
}

export default Start


